import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { FormsEnum } from 'src/app/models/enums/forms.enum';
import { JsonContentEnum } from 'src/app/models/enums/json-content.enum';
import { LogService } from 'src/app/modules/shared/services/log.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MapaAn } from '../../../../shared/models/component-messages/mapaAN/mapa_an';
import { CanNavigateInStepperService } from '../../../../shared/services/can-navigate-in-stepper.service';
import { ObjectToJsonStepperCreatorService } from '../../../../shared/services/object-to-json-stepper-creator.service';
import { TypeAnn } from '../../../common/models/type.ann';
import { AnnonceurService } from '../../../common/services/annonceur/annonceur.service';
import { FormulaireServiceService } from '../../../services/formulaire-service.service';
import { Annulation } from '../models/Annulation';
import { AvisDataTransferService } from '../../../../shared/services/avis-data-transfer.service';
import { StepperBuilderService } from '../../../../avisDePub/creer/services/stepper.builder.service';
import { ContenuPdf } from '../../../common/models/contenuPdf';


@Component({
  selector: 'app-annulationformmapa',
  templateUrl: './formmapa.component.html'
})
export class FormMAPA_ANComponent implements OnInit {

  private LOG: LogService = new LogService(FormMAPA_ANComponent);

  @Input() indexPage;
  @Input() disabled = true;
  @Input() linkForRouter: string;
  @Input() tableClass: string;
  @Input() formClass: string;
  @Input() form: FormGroup;
  @Input() referenceAvis: string;
  @Input() currentJson: any = new BehaviorSubject(null);
  public mapaAnnulationForm = new Annulation();
  public createForm = false;
  @Input() formName: string;
  @Input() diffBoamp: boolean = false;
  @Input() diffJoue: boolean = false;
  private isLierAvisSelected :boolean=false;

  public ann: TypeAnn = new TypeAnn();
  public steps = [5, 6, 8, 9, 18, 19];
  public mapaAn = new MapaAn()
  public pages: number[];

  constructor(private formulaireServiceService: FormulaireServiceService,
    private spinner: SpinnerVisibilityService,
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
    private annonceurService: AnnonceurService,
    private canNavigateInStepperService: CanNavigateInStepperService,
    private avisDataTransferService:AvisDataTransferService,
    private stepperBuilderService: StepperBuilderService
    ) {
  }

  public ngOnInit() {
    this.pages = Array.from({ length: 4 }, (_, index) => index + 1);
    this.initForm();
  }

  public validateForm() {
  }

  private initForm() {
    this.isLierAvisSelected=this.canNavigateInStepperService.isCreerAvisLierSelected;
    this.spinner.show();
    this.currentJson.subscribe(data => {
      if (data != null && typeof data != 'string' && !this.createForm) {
        this.ann = data.jsonSaisieFormulaire.ann;
        if (data.jsonSaisieFormulaire.stepId && this.indexPage>0.4)
          this.indexPage = data.jsonSaisieFormulaire.stepId;
        this.createForm = true;
        this.canNavigateInStepperService.isBOAMPorJOUE = null;
        this.canNavigateInStepperService.isSHALorPS = null;
        this.annonceurService.annonceurBhs.next(data.jsonSaisieFormulaire.annonceur);
        this.avisDataTransferService.setFormData(data);
        this.stepperBuilderService.prepareMapErrors(data.jsonFieldsErrorsWarnings);
        this.avisDataTransferService.jsonCSV = data.jsonCSV;
        this.avisDataTransferService.contenuPdf = data.jsonPdf;
        this.spinner.hide();
      } else {
        this.formulaireServiceService.getAvis(this.referenceAvis, FormsEnum.MAPA_AN, JsonContentEnum.EMPTY, data).subscribe(formData => {
          this.createForm = true;
          this.annonceurService.annonceurBhs.next(formData.jsonSaisieFormulaire.annonceur);
          this.ann = formData.jsonSaisieFormulaire.ann;
					const fluxAllerPA: any = formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos ? { ...formData.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos } : null;
					this.avisDataTransferService.sourceAppProfilAcheteurInfos = fluxAllerPA;
          this.avisDataTransferService.refConsultation=formData.refConsultation;
          this.avisDataTransferService.siret=formData.jsonSaisieFormulaire.ann.facturation.libelle.siret;
          this.avisDataTransferService.setFormData(formData);
          if (this.canNavigateInStepperService.isCreerAvisLierSelected && this.canNavigateInStepperService.isAvisLierNational && JSON.stringify(formData.jsonCSV).includes('{}')) {
            this.stepperBuilderService.prepareMapErrors(formData.jsonFieldsErrorsWarnings);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 1);
            this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_' + 2);
            this.stepperBuilderService.initFormLiePDF('assets/data/formPDF/lieForms/' + FormsEnum[FormsEnum.MAPA_AN] + '.json').subscribe(
              (json) => {
                this.avisDataTransferService.contenuPdf = new ContenuPdf();
                this.avisDataTransferService.contenuPdf.champs = json;
                this.stepperBuilderService.PDFAvisLiesSetted.next({json:json,formData:formData});
                return json;
              }
            );
          }
          else {
          this.stepperBuilderService.initDefaultMapErrors('assets/data/errors/' + FormsEnum[FormsEnum.MAPA_AN] + '.json');
          this.stepperBuilderService.initDefaultFormAD('assets/data/formAD/' + FormsEnum[FormsEnum.MAPA_AN] + '.json');
          this.stepperBuilderService.initDefaultFormPDF('assets/data/formPDF/' + FormsEnum[FormsEnum.MAPA_AN] + '.json');
          }
          this.spinner.hide();
        });
      }
    });
  }

  getIsCheckValid(indexPage) {
    return this.stepperBuilderService.getIsCheckValidate('_STEP_ID_' + indexPage);
  }

  public getUid(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Annulation';
  }

  getUidCommon(indexPage) {
    return '_STEP_ID_' + indexPage + '_SepSep_Annonce_index_1_SepSep_TypeAnn';
  }

  getIntitule(indexPage) {
    return this.formulaireServiceService.hasTranslation(
      this.mapaAn.step + indexPage
    )
      ? this.mapaAn.step + indexPage
      : this.mapaAn.commonStep + indexPage;
  }

  getContents(indexPage) {
    switch (indexPage) {
      case this.steps[0]:
        return [];
      case this.steps[1]:
        return [];
      case this.steps[2]:
        return [];
      case this.steps[3]:
        return [];
      case this.steps[4]:
        return [];
      case this.steps[5]:
        return [];
    }
  }
}
